function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "minus_simple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.421875 10.457031 L 0.578125 10.457031 C 0.257812 10.457031 0 10.714844 0 11.035156 L 0 12.964844 C 0 13.285156 0.257812 13.542969 0.578125 13.542969 L 23.421875 13.542969 C 23.742188 13.542969 24 13.285156 24 12.964844 L 24 11.035156 C 24 10.714844 23.742188 10.457031 23.421875 10.457031 Z M 23.421875 10.457031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusSimple);
export default __webpack_public_path__ + "static/media/minus_simple.ff2dacfb9703e2a1c7844082ee299f5f.svg";
export { ForwardRef as ReactComponent };